<template>
  <div
    class="DetailFaqs">
    <h3 class="pb-2">FAQ</h3>
    <BaseAccordion
      v-for="faq in faqs"
      :key="faq.question">
      <template
        #title>
        <div>
          {{ faq.question }}
        </div>
      </template>
      <template
        #content>
        <div
          v-html="faq.answers[0]">
        </div>
      </template>
    </BaseAccordion>
  </div>
</template>

<script>
import BaseAccordion from '@/components/BaseAccordion.vue';

export default {
  name: 'DetailFaqs',

  components: {
    BaseAccordion,
  },

  props: {
    faqs: { type: Array, required: true },
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables';

.DetailFaqs {
  list-style: inside;
}

.DetailFaqs table {
  width: 100%;
  margin-top: 8px;
  color: $dark;
  font-size: 12px;
  border: 1px solid rgba($black, .2);
  border-bottom: none;
  border-collapse: separate;
  border-spacing: 0;
  & th,
  & td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid rgba($black, .2);
  }
  & th {
    font-weight: bold;
  }
}
</style>
